/**
 * 파일 이름 추출
 * @description 파일 Url 에서 파일 이름 + 확장자 추출
 */
export const useExtractFileName = (url: string) => ({
  name: url.substring(url.lastIndexOf('/') + 1),
  extension: url.split(/[#?]/)[0].split('.').pop()?.trim() || '',
})
